import { useEffect } from 'react';
import { getVegaOsApi } from 'utils/vegaos/VegaOsApi';
import { useAppContext } from '../context/app-context';
import {
  Device,
  DeviceSubtype,
  getDevice,
  getDeviceSubtype,
  updateCachedDeviceCaptionsEnabled,
  updateCachedOsVersion,
} from '../utils/getDevice';
import { datadogRum } from '@datadog/browser-rum';

export type DeviceInfo = {
  platform?: string;
  modelName?: string;
  version?: string;
};

const device = getDevice();
export const useDatadogDevice = () => {
  const { webosDeviceInfo } = useAppContext();

  useEffect(() => {
    if (device === Device.lgtv && webosDeviceInfo) {
      const deviceInfo: DeviceInfo = {
        platform: Device.lgtv,
        modelName: webosDeviceInfo.modelName,
        version: webosDeviceInfo.sdkVersion,
      };
      datadogRum.setGlobalContextProperty('deviceInfo', deviceInfo);
    }
  }, [webosDeviceInfo]);

  useEffect(() => {
    if (device === Device.androidtv || device === Device.firetv) {
      if (getDeviceSubtype() === DeviceSubtype.none && window && self.Android) {
        const deviceInfo: DeviceInfo = {
          modelName: self.Android.getModelName(),
          version: self.Android.getApiLevel(),
        };
        if (device === Device.androidtv) {
          deviceInfo.platform = Device.androidtv;
          datadogRum.setGlobalContextProperty('deviceInfo', deviceInfo);
        } else if (device === Device.firetv) {
          deviceInfo.platform = Device.firetv;
          datadogRum.setGlobalContextProperty('deviceInfo', deviceInfo);
        }
      } else if (getDeviceSubtype() === DeviceSubtype.vegaos && window && self.ReactNativeWebView) {
        const deviceInfo: DeviceInfo = {
          platform: DeviceSubtype.vegaos,
          modelName: getVegaOsApi()?.getBuildInfo?.()?.model,
          version: getVegaOsApi()?.getBuildInfo?.()?.systemVersion,
        };
        datadogRum.setGlobalContextProperty('deviceInfo', deviceInfo);
      }
    }
  }, []);

  useEffect(() => {
    if (device === Device.xbox) {
      if (window?.UWP) {
        const deviceInfo: DeviceInfo = {
          platform: Device.xbox,
          modelName: self.UWP.model,
          version: self.UWP.modelVersion,
        };
        datadogRum.setGlobalContextProperty('deviceInfo', deviceInfo);
      }
    }
  }, []);

  useEffect(() => {
    if (device === Device.tizen) {
      if (window.tizen && window.webapis) {
        const model = window.webapis.productinfo.getRealModel();
        const version = window.tizen.systeminfo.getCapability('http://tizen.org/feature/platform.version');
        const isCaptionEnabled = window.tizen.tvinfo.getCaptionValue('CAPTION_ONOFF_KEY') === 'CAPTION_ON';
        const deviceInfo: DeviceInfo = {
          platform: Device.tizen,
          modelName: model ?? '',
          version: version ?? '',
        };
        updateCachedOsVersion(version);
        updateCachedDeviceCaptionsEnabled(isCaptionEnabled);
        datadogRum.setGlobalContextProperty('deviceInfo', deviceInfo);
      }
    }
  }, []);
};
